import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
// import { Link } from "@mui/material";
// import Link from '@mui/material/Link';
import { Grid, Link } from "@mui/material";
import { customColors, CustomColors } from "../../../styles/CustomColors";

interface BreadcrumbProps {
  colors?: CustomColors;
}

function handleClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
  if (event.target && !(event.target as HTMLAnchorElement).href) {
    event.preventDefault();
    console.info("You clicked a breadcrumb.");
  }
}

const BasicBreadcrumbs = ({ colors = customColors }: BreadcrumbProps) => {
  return (
    <Grid
      role="navigation"
      sx={{
        display: "block",
        fontsize: "1rem",
        margin: "20px 0 24px",
        minHeight: "2.5rem",
        minWidth: "41.75rem",
        paddingbottom: "12px",
        paddingtop: "12px",
        wordWrap: "break-word",
        mb: ".5rem",
        lineHeight: "1.5",
        justifyContent: "center",
      }}
      onClick={handleClick}
    >
      <Breadcrumbs
        separator="»"
        aria-label="breadcrumb"
        role="navigation"
        sx={{
          display: "inline",
          paddingRight: ".55rem",
          color: "#000",
          fontSize: ".9rem",
          lineHeight: "normal",
        }}
      >
        <Link
          underline="hover"
          color="inherit"
          sx={{
            paddingRight: ".55rem",
            display: "inline",
            fontSize: "1rem",
            color: colors.oceanBlueBg,
            textDecoration: "underline",
            "&:hover": {
              textDecoration: "none",
              color: "#000",
            },
          }}
          href="https://www.energystar.gov"
        >
          Home
        </Link>
        <Link
          underline="hover"
          color="inherit"
          sx={{
            paddingRight: ".55rem",
            paddingLeft: ".55rem",
            fontSize: "1rem",
            color: colors.oceanBlueBg,
            textDecoration: "underline",
            "&:hover": {
              textDecoration: "none",
              color: "#000",
            },
          }}
          href="https://www.energystar.gov/products"
        >
          Energy Efficient Products
        </Link>
        <Typography
          aria-current="page"
          sx={{
            color: "#000",
            fontSize: "1rem",
            paddingRight: ".55rem",
            paddingLeft: ".55rem",
          }}
        >
          {" "}
          ENERGY STAR Most Efficient {import.meta.env.VITE_MOSTEFFICIENTYEAR}
        </Typography>
      </Breadcrumbs>
    </Grid>
  );
};

export default BasicBreadcrumbs;
